import { useSelector } from "react-redux";

const ImageBlock = ({ block }) => {
  const content = block.content;
  return (
    <img
      src={`${content.src}`}
      alt={content.alt}
      className="image-block"
      style={{ maxWidth: content.width || '100%' }}
    />
  );
};

export default ImageBlock;